import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ProjectsContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
          
        
        this.setState({loading:0})
       
           
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
 <div class="portfolio-area circle-icon default-padding bottom-less">
		<div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="site-heading text-center">
        
          <h2>PROJECT LIST SUMMARY</h2>
         
        </div>
      </div>
    </div>
  </div>
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    
                    <div class="row masonary">
                        <div id="portfolio-grid" class="portfolio-items col-3">
                            <div class="portfolio-items">
                                 
                            {this.props.projects.map((item, index) => (
                                <div class="pf-item construction pf-project">
                                    <div class="item">
                                        <div class="effect-up">
                                            <img src={item.image} alt={item.title} />
                                            <div class="overlay">
                                                <div class="link">
                                                    <Link to={item.image} class="item popup-gallery"><i class="fa fa-search"></i></Link >
                                                    <Link to={base_url+`project-info/${item.slug}`}><i class="fas fa-link"></i></Link >
                                                </div>
                                            </div>           
                                        </div>
                                        <div class="info">
                                            <h3>{item.title}</h3>
                                            
                                            
                                        </div>
                                    </div>
                                </div>
                                 
                               ))} 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        </div>
       

    );
 
    }
}

export default ProjectsContent;